import { MutationTree } from 'vuex'
import { VideoState } from '@/store/modules/video/index'
export default {
  setVideoUrls: (state, videos) => {
    state.videoUrls = videos
  }
} as MutationTree<VideoState>
